'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _filterData = require('../filterData');

var _filterData2 = _interopRequireDefault(_filterData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (container, scales, config) {
    return function (data) {
        var result = [];

        if (!config.displayLabels) {
            if (data && !data.length) {
                return;
            }

            data.forEach(function (d) {
                var count = (0, _filterData2.default)(d.data, scales.x, config.date).length;
                result.push({ name: d.name, count: count });
            });

            return result;
        }

        var labels = void 0;
        if (data) {
            labels = container.selectAll('.label').data(data);
        } else {
            labels = container.selectAll('.label');
        }

        var text = function text(d) {
            var count = (0, _filterData2.default)(d.data, scales.x, config.date).length;
            result.push({ name: d.name, count: count });
            return d.name + (count > 0 ? ' (' + count + ')' : '');
        };

        labels.text(text);

        labels.enter().append('text').classed('label', true).attr('x', config.labelsWidth).attr('transform', function (d, idx) {
            return 'translate(0, ' + (40 + scales.y(idx)) + ')';
        }).attr('text-anchor', 'end').text(text);

        labels.exit().remove();
        return result;
    };
};
//# sourceMappingURL=labels.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/ansyn-event-drops/dist-es5/drawer/labels.js
// module id = ../../../../ansyn-event-drops/dist-es5/drawer/labels.js
// module chunks = vendor